export default __webpack_public_path__ + "128d08b9338f1fde3e3524b02811edfa.svg";